/**
 * renderingConstants.js — shared status tokens for the Rendering Studio.
 *
 * These were previously exported from mockRenderingStudio.js. They are the
 * only two exports of that mock module that outlive R3a, so they now live
 * here (§6.6 A4) and the mock module can be stripped/deleted (§6.6 A5).
 *
 * The strings must stay in lock-step with the server-side RenderUnit
 * status / preflight vocabulary.
 */

export const UNIT_STATUS = {
  NOT_RENDERED: "not_rendered",
  PARTIAL: "partial",
  COMPLETE: "complete",
  STALE: "stale",
};

export const PREFLIGHT_STATUS = {
  GREEN: "green",
  AMBER: "amber",
  RED: "red",
};
